import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";
import * as React from "react";
import { LogOut } from "lucide-react";
import { getCurrentUser } from "aws-amplify/auth";

import { useAuth } from "../auth";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ location }) => {
    let isAuthenticated = false;
    try {
      const current = await getCurrentUser();
      isAuthenticated = !!current;
    } catch {}
    if (!isAuthenticated) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const auth = useAuth();
  const router = useRouter();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await auth.logout();
      await router.invalidate();
      await navigate({ to: "/login", replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <main className="flex min-h-svh container mx-auto flex-col py-6 md:py-10">
      <header className="mb-5 flex w-full min-w-0 shrink-0 items-center justify-between gap-4 border-b border-border pb-4">
        <Link
          to="/"
          className="text-foreground min-w-0 truncate text-lg font-semibold tracking-tight transition-colors hover:text-muted-foreground"
        >
          Onboarding Helper
        </Link>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="shrink-0 text-muted-foreground hover:text-foreground"
          disabled={isLoggingOut}
          onClick={() => void handleLogout()}
        >
          <LogOut className="mr-2 h-4 w-4" />
          {isLoggingOut ? "Signing out…" : "Log out"}
        </Button>
      </header>
      <div className="min-w-0 w-full max-w-full flex-1 overflow-x-hidden">
        <Outlet />
      </div>
    </main>
  );
}
